const translations = {
    "FR": {
        title: "DAY-DROP",
        name: "Nom",
        phoneNumber: "Numéro de téléphone",
        nativeLanguage: "Langue maternelle",
        preferredLanguage: "Langue préférée",
        nationality: "Nationalité",
        optIn: "S'inscrire aux mises à jour",
        preferredTime: "Heure préférée",
        city: "Ville",
        timezone: "Fuseau horaire",
        submit: "Soumettre",
        subscriptionTitle: "Plan d'abonnement",
        subscriptionStartDate: "Date de début d'abonnement",
        month3: "3 mois",
        month6: "6 mois",
        month12: "12 mois",
        price: "EUR",
        select: "Sélectionner",
        back: "Retour",
        countries: {
            "FR": "Français",
            "KR": "Coréen",
            "GE": "Allemand",
            "ES": "Espagnol",
            "EN-US": "Anglais (États-Unis)",
            "EN-GB": "Anglais (Royaume-Uni)",
            "IT": "Italien",
            "PT": "Portugais"
        }
    },
    "KR": {
        title: "DAY-DROP",
        name: "이름",
        phoneNumber: "전화번호",
        nativeLanguage: "모국어",
        preferredLanguage: "학습할 언어",
        nationality: "국적",
        optIn: "업데이트 알림 받기",
        preferredTime: "선호하는 시간",
        city: "도시",
        timezone: "시간대",
        submit: "제출",
        subscriptionTitle: "구독 플랜",
        subscriptionStartDate: "구독 시작 날짜",
        month3: "3개월",
        month6: "6개월",
        month12: "12개월",
        price: "EUR",
        select: "선택",
        back: "뒤로가기",
        countries: {
            "FR": "프랑스어",
            "KR": "한국어",
            "GE": "독일어",
            "ES": "스페인어",
            "EN-US": "영어 (미국)",
            "EN-GB": "영어 (영국)",
            "IT": "이탈리아어",
            "PT": "포르투갈어"
        }
    },
    "GE": {
        title: "DAY-DROP",
        name: "Name",
        phoneNumber: "Telefonnummer",
        nativeLanguage: "Muttersprache",
        preferredLanguage: "Bevorzugte Sprache",
        nationality: "Nationalität",
        optIn: "Updates abonnieren",
        preferredTime: "Bevorzugte Zeit",
        city: "Stadt",
        timezone: "Zeitzone",
        submit: "Einreichen",
        subscriptionTitle: "Abonnementplan",
        subscriptionStartDate: "Startdatum des Abonnements",
        month3: "3 Monate",
        month6: "6 Monate",
        month12: "12 Monate",
        price: "EUR",
        select: "Auswählen",
        back: "Zurück",
        countries: {
            "FR": "Französisch",
            "KR": "Koreanisch",
            "GE": "Deutsch",
            "ES": "Spanisch",
            "EN-US": "Englisch (USA)",
            "EN-GB": "Englisch (UK)",
            "IT": "Italienisch",
            "PT": "Portugiesisch"
        }
    },
    "ES": {
        title: "DAY-DROP",
        name: "Nombre",
        phoneNumber: "Número de teléfono",
        nativeLanguage: "Lengua materna",
        preferredLanguage: "Idioma preferido",
        nationality: "Nacionalidad",
        optIn: "Suscribirse a actualizaciones",
        preferredTime: "Hora preferida",
        city: "Ciudad",
        timezone: "Zona horaria",
        submit: "Enviar",
        subscriptionTitle: "Plan de suscripción",
        subscriptionStartDate: "Fecha de inicio de la suscripción",
        month3: "3 meses",
        month6: "6 meses",
        month12: "12 meses",
        price: "EUR",
        select: "Seleccionar",
        back: "Volver",
        countries: {
            "FR": "Francés",
            "KR": "Coreano",
            "GE": "Alemán",
            "ES": "Español",
            "EN-US": "Inglés (EE.UU.)",
            "EN-GB": "Inglés (Reino Unido)",
            "IT": "Italiano",
            "PT": "Portugués"
        }
    },
    "EN-US": {
        title: "DAY-DROP",
        name: "Name",
        phoneNumber: "Phone Number",
        nativeLanguage: "Native Language",
        preferredLanguage: "Preferred Language",
        nationality: "Nationality",
        optIn: "Opt-in for updates",
        preferredTime: "Preferred Time",
        city: "City",
        timezone: "Timezone",
        submit: "Submit",
        subscriptionTitle: "Subscription Plan",
        subscriptionStartDate: "Subscription Start Date",
        month3: "3 months",
        month6: "6 months",
        month12: "12 months",
        price: "EUR",
        select: "Select",
        back: "Back",
        countries: {
            "FR": "French",
            "KR": "Korean",
            "GE": "German",
            "ES": "Spanish",
            "EN-US": "English (US)",
            "EN-GB": "English (UK)",
            "IT": "Italian",
            "PT": "Portuguese"
        }
    },
    "EN-GB": {
        title: "DAY-DROP",
        name: "Name",
        phoneNumber: "Phone Number",
        nativeLanguage: "Native Language",
        preferredLanguage: "Preferred Language",
        nationality: "Nationality",
        optIn: "Opt-in for updates",
        preferredTime: "Preferred Time",
        city: "City",
        timezone: "Timezone",
        submit: "Submit",
        subscriptionTitle: "Subscription Plan",
        subscriptionStartDate: "Subscription Start Date",
        month3: "3 months",
        month6: "6 months",
        month12: "12 months",
        price: "EUR",
        select: "Select",
        back: "Back",
        countries: {
            "FR": "French",
            "KR": "Korean",
            "GE": "German",
            "ES": "Spanish",
            "EN-US": "English (US)",
            "EN-GB": "English (UK)",
            "IT": "Italian",
            "PT": "Portuguese"
        }
    },
    "IT": {
        title: "DAY-DROP",
        name: "Nome",
        phoneNumber: "Numero di telefono",
        nativeLanguage: "Lingua madre",
        preferredLanguage: "Lingua preferita",
        nationality: "Nazionalità",
        optIn: "Iscriviti agli aggiornamenti",
        preferredTime: "Orario preferito",
        city: "Città",
        timezone: "Fuso orario",
        submit: "Invia",
        subscriptionTitle: "Piano di abbonamento",
        subscriptionStartDate: "Data di inizio abbonamento",
        month3: "3 mesi",
        month6: "6 mesi",
        month12: "12 mesi",
        price: "EUR",
        select: "Seleziona",
        back: "Indietro",
        countries: {
            "FR": "Francese",
            "KR": "Coreano",
            "GE": "Tedesco",
            "ES": "Spagnolo",
            "EN-US": "Inglese (USA)",
            "EN-GB": "Inglese (UK)",
            "IT": "Italiano",
            "PT": "Portoghese"
        }
    },
    "PT": {
        title: "DAY-DROP",
        name: "Nome",
        phoneNumber: "Número de telefone",
        nativeLanguage: "Língua nativa",
        preferredLanguage: "Idioma preferido",
        nationality: "Nacionalidade",
        optIn: "Inscrever-se para atualizações",
        preferredTime: "Horário preferido",
        city: "Cidade",
        timezone: "Fuso horário",
        submit: "Enviar",
        subscriptionTitle: "Plano de assinatura",
        subscriptionStartDate: "Data de início da assinatura",
        month3: "3 meses",
        month6: "6 meses",
        month12: "12 meses",
        price: "EUR",
        select: "Selecionar",
        back: "Voltar",
        countries: {
            "FR": "Francês",
            "KR": "Coreano",
            "GE": "Alemão",
            "ES": "Espanhol",
            "EN-US": "Inglês (EUA)",
            "EN-GB": "Inglês (Reino Unido)",
            "IT": "Italiano",
            "PT": "Português"
        }
    }
};

export default translations;
